import KeyAccountRepairFileOpeningWarningModal from '@/components/repair-files/modals/KeyAccountRepairFileOpeningWarningModal.vue'
import RepairFileService from '@/services/RepairFileService'
import { displayModal } from '@/utils/modalUtils'
import { getRepairFilePayload, shouldShowKeyAccountOpeningWarning } from '@/utils/repairFileUtils'

function hasWarningDetails(repairFile) {
  return (
    repairFile?.step && repairFile?.status_macro && Array.isArray(repairFile?.delivery_address_list)
  )
}

async function getRepairFileWithWarningDetails(repairFile, repairFileBoomerangId) {
  const repairFilePayload = getRepairFilePayload(repairFile)
  if (hasWarningDetails(repairFilePayload)) {
    return repairFilePayload
  }

  return await RepairFileService.get(repairFileBoomerangId || repairFilePayload?.boomerang_id)
}

export async function confirmKeyAccountRepairFileOpening({
  repairFile,
  repairFileBoomerangId,
  markAsRead
}) {
  let repairFilePayload = getRepairFilePayload(repairFile)
  if (!repairFilePayload && repairFileBoomerangId) {
    repairFilePayload = await RepairFileService.get(repairFileBoomerangId)
  }

  if (!shouldShowKeyAccountOpeningWarning(repairFilePayload)) {
    await markAsRead?.(repairFilePayload)
    return true
  }

  const repairFileWithDetails = await getRepairFileWithWarningDetails(
    repairFile,
    repairFileBoomerangId
  )

  const acknowledged = await displayModal({
    component: KeyAccountRepairFileOpeningWarningModal,
    props: {
      repairFile: repairFileWithDetails
    },
    maxWidth: 620,
    persistent: true
  })

  if (!acknowledged) {
    return false
  }

  await RepairFileService.acknowledgeKeyAccountWarning(
    repairFileBoomerangId || repairFileWithDetails?.boomerang_id
  )
  repairFileWithDetails.key_account_warning_acknowledged = true
  repairFilePayload.key_account_warning_acknowledged = true
  await markAsRead?.(repairFileWithDetails)
  return true
}
